import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Header from './components/Header';
import Footer from './components/Footer';
import Transactions from './features/transactions/Transactions';
import TransactionForm from './pages/TransactionForm';
import Categories from './pages/Categories';
import CategoryForm from './pages/CategoryForm';
import CreditCards from './pages/CreditCards';
import CreditCardForm from './pages/CreditCardForm';
import Dashboard from './features/dashboard/Dashboard';
import InitialBalance from './pages/InitialBalance';
import Reports from './pages/Reports';
import CategoryReport from './pages/CategoryReport';
import CategoryAnalysis from './pages/CategoryAnalysis';
import TemporalAnalysis from './pages/TemporalAnalysis';
import MonthlyComparison from './pages/MonthlyComparison';
import YearlySummary from './pages/YearlySummary';
import FinancialInsights from './pages/FinancialInsights';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppProvider>
                <div className="app-container">
                  <Header />
                  <div className="content-container">
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/transactions" element={<Transactions />} />
                      <Route path="/transactions/new" element={<TransactionForm />} />
                      <Route path="/transactions/:id" element={<TransactionForm />} />
                      <Route path="/categories" element={<Categories />} />
                      <Route path="/categories/new" element={<CategoryForm />} />
                      <Route path="/categories/:id" element={<CategoryForm />} />
                      <Route path="/credit-cards" element={<CreditCards />} />
                      <Route path="/credit-cards/new" element={<CreditCardForm />} />
                      <Route path="/credit-cards/:id" element={<CreditCardForm />} />
                      <Route path="/initial-balance" element={<InitialBalance />} />
                      <Route path="/reports" element={<Reports />} />
                      <Route path="/reports/category" element={<CategoryReport />} />
                      <Route path="/reports/category-analysis" element={<CategoryAnalysis />} />
                      <Route path="/reports/temporal-analysis" element={<TemporalAnalysis />} />
                      <Route path="/reports/monthly-comparison" element={<MonthlyComparison />} />
                      <Route path="/reports/yearly-summary" element={<YearlySummary />} />
                      <Route path="/reports/financial-insights" element={<FinancialInsights />} />
                    </Routes>
                  </div>
                  <Footer />
                </div>
              </AppProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App; 